EmailFormV2FlexibleContactChannelsView = require "../common/v2_flexible_contact_channels"

class EmailFormIntlV2FlexibleContactChannelsView extends EmailFormV2FlexibleContactChannelsView
  toHash: (hash) ->
    hash = EmailFormV2FlexibleContactChannelsView::toHash.call(this, hash)
    hash.isVertical = true
    hash

  arrangeLayoutView: (hash) ->
    $container = EmailFormV2FlexibleContactChannelsView::arrangeLayoutView.call(this, hash)
    $container.find('.flexible-contact-channel-text-container').addClass('eight columns')
    $container.find('.flexible-contact-channel-icon-container').addClass('four columns')
    $container

module.exports = EmailFormIntlV2FlexibleContactChannelsView
